export function valueToRiskBracket (riskRating) {
  let value = parseFloat(riskRating)
  switch (true) {
    case value <= 1.8:
      return 'Conservative'
      break
    case value <= 2.6:
      return 'Moderate Conservative'
      break
    case value <= 3.4:
      return 'Moderate'
      break
    case value <= 4.2:
      return 'Moderate Aggressive'
      break
    default:
      return 'Aggressive'
  }
}
